import { BaseModel } from './BaseModel';

export class Payment extends BaseModel {
  static get entity() {
    return 'payments';
  }
  static get fk() {
    return 'payment_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      status: this.attr(''),
      payment_method: this.attr(''),
      tx_id: this.string(null).nullable(),
      reference1: this.string(null).nullable(),
      reference2: this.string(null).nullable(),
      reference3: this.string(null).nullable(),
      due_date: this.attr(null).nullable(),
      qr_code: this.string(null).nullable(),
      updated_at: this.attr(null),
      created_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {}
  };
}

export default Payment;
